// extracted by mini-css-extract-plugin
export default {"imgWrapper":"ImageCardContent_imgWrapper__M23bk","img":"ImageCardContent_img__kp1pZ"};